module.exports = __webpack_public_path__ + "img/hypergraph_logo_purple.d4575823.png";